import { FC, useState } from 'react';
import { Popover } from '@mantine/core';
import {
  useGetCustomersListQuery,
  useChooseCustomerMutation,
} from 'redux/Api/authApi/authApi';
import { useDispatch } from 'react-redux';
import { ordersApi } from 'redux/Api/ordersApi/ordersApi';
import { beneficiariesApi } from 'redux/Api/beneficiariesApi/beneficiariesApi';
import { employedsApi } from 'redux/Api/employedsApi/employedsApi';
import { operationsApi } from 'redux/Api/operationsApi/operationsApi';
import { profileApi } from 'redux/Api/profileApi/ProfileApi';
import styles from './CompanySelect.module.scss';
import { ReactComponent as IconChevron } from './img/iconChewron.svg';
import { logIn } from 'redux/auth/slice';
import { getCompanyInitials } from 'utils/strActions';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import useYandexMetrica from 'hooks/useYandexMetrica';

interface CompanySelectProps {
  currentCompanyId?: number;
  currentCompanyName?: string;
}

export const CompanySelect: FC<CompanySelectProps> = ({
  currentCompanyId,
  currentCompanyName = '',
}) => {
  const [opened, setOpened] = useState(false);
  const dispatch = useDispatch();
  const { data: customersList, isLoading } = useGetCustomersListQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnReconnect: false,
    refetchOnFocus: false,
  });
  const [chooseCustomer] = useChooseCustomerMutation();
  const { sendGoal } = useYandexMetrica();

  const handleSelectCustomer = async (customerId: number) => {
    if (customerId === currentCompanyId) {
      setOpened(false);
      return;
    }
    sendGoal('ChangeCustomer');
    try {
      const response = await chooseCustomer({ customer_id: customerId }).unwrap();
      console.log('Поменялся заказчик', response.role);
      localStorage.removeItem('chatToken');

      if (response.token) {
        localStorage.setItem('token', response.token);

        const roleToStore = response.role === 'employee' ? 'director' : response.role;
        localStorage.setItem('role', roleToStore);
        localStorage.setItem('can_manage', response.can_manage ? 'true' : 'false');

        dispatch(logIn(response.token));

        dispatch(ordersApi.util.resetApiState());
        dispatch(beneficiariesApi.util.resetApiState());
        dispatch(employedsApi.util.resetApiState());
        dispatch(operationsApi.util.resetApiState());
        dispatch(profileApi.util.resetApiState());

        setOpened(false);
        window.location.reload();
      } else {
        console.log('Ошибка авторизации - токен не получен');
      }

      setOpened(false);
    } catch (error) {
      console.error('Не удалось выбрать заказчика:', error);
      setOpened(false);
    }
  };

  if (isLoading || !currentCompanyId) {
    return null;
  }

  if (!customersList || customersList.length <= 1) {
    return null;
  }

  return (
    <Popover
      width={'fit-content'}
      position='bottom-start'
      shadow='md'
      opened={opened}
      onChange={setOpened}>
      <Popover.Target>
        <div className={styles.trigger} onClick={() => setOpened(!opened)}>
          <span className={styles.textWrapper}>
            <TextWithTooltip
              content={getCompanyInitials(currentCompanyName, true)}
              className={styles.truncate}
            />
          </span>
          <div>
            <IconChevron />
          </div>
        </div>
      </Popover.Target>

      <Popover.Dropdown className={styles.companiesList}>
        {customersList?.map((customer) => (
          <div
            key={customer.id}
            className={styles.companyItem}
            onClick={() => handleSelectCustomer(customer.id)}>
            <div className={styles.companyInitials}>
              {getCompanyInitials(customer.name)}
            </div>
            <span className={styles.companyName}>
              <TextWithTooltip content={customer.name} className={styles.companyName} />
            </span>
          </div>
        ))}
      </Popover.Dropdown>
    </Popover>
  );
};
